export function fbTrack(eventType: string, eventName: string, parameters: facebook.Pixel.ViewContentParameters) {
  if (process.env.NODE_ENV === `production`) {
    window.fbq(eventType, eventName, parameters);
  }
}
